// Sheet metal bend math.
// References: K-factor / neutral-axis method, used by SolidWorks, Onshape, SendCutSend, etc.

export function deg2rad(d: number) {
  return (d * Math.PI) / 180;
}

// Bend Allowance: arc length along the neutral axis through the bend region.
// BA = (π/180) * |angle_deg| * (R + K * T)
export function bendAllowance(angleDeg: number, radius: number, thickness: number, k: number) {
  const a = Math.abs(angleDeg);
  return (a * Math.PI / 180) * (radius + k * thickness);
}

// Outside Setback: how far the apex of the bend extends beyond the tangent line
// from each adjacent flange. OSSB = tan(angle/2) * (R + T)
export function outsideSetback(angleDeg: number, radius: number, thickness: number) {
  const a = Math.abs(angleDeg);
  return Math.tan((a * Math.PI / 180) / 2) * (radius + thickness);
}

// Inside Setback: distance from the bend tangent on a flange to the inner corner
// (= virtual sharp on the inside of the bend). ISSB = tan(angle/2) * R
export function insideSetback(angleDeg: number, radius: number) {
  const a = Math.abs(angleDeg);
  return Math.tan((a * Math.PI / 180) / 2) * radius;
}

// Bend Deduction: amount to subtract from the sum of outside-to-bend dimensions
// to get the flat blank length. BD = 2*OSSB - BA.
export function bendDeduction(angleDeg: number, radius: number, thickness: number, k: number) {
  return 2 * outsideSetback(angleDeg, radius, thickness) - bendAllowance(angleDeg, radius, thickness, k);
}
